import { getNameFromUrl, getPartsNameFromUrl } from "../system/path";
import { GALLERY } from "../data.types";

const _lowerTypeGallery = GALLERY.toLowerCase();

const _getDescription = (names, languages) => {
  let result = {};
  languages
    .map(lang => lang.id)
    .forEach(lang => {
      let item = names.find(n => n.id === lang);
      if (item) {
        result[lang] = item.value;
      } else {
        result[lang] = "";
      }
    });
  return result;
};

const getGalleryValueData = (actionValue, languages) => {
  let glr = [];

  if (actionValue.props.value && actionValue.props.value[_lowerTypeGallery]) {
    actionValue.props.value[_lowerTypeGallery].forEach(g => {
      glr.push({
        url: g.url,
        description: _getDescription(g.names, languages),
        preview: g.preview,
        numberInOrder: g.numberInOrder
      });
    });
  }

  return {
    attributeId: actionValue.props.attributeId,
    [_lowerTypeGallery]: glr
  };
};

const resortGalleryList = list => {
  list.sort((a, b) => {
    return a.numberInOrder < b.numberInOrder ? -1 : 1;
  });
};

const getNextNumberInOrderNum = rows => {
  return (
    Math.max(
      ...rows
        .filter(t => t.numberInOrder !== undefined)
        .map(t => t.numberInOrder),
      0
    ) + 1
  );
};

const recalcGalleryOrderNum = (rows, index) => {
  let val = rows[index];

  if (val.numberInOrder === undefined) {
    val.numberInOrder = getNextNumberInOrderNum(rows);
  }

  let newIndex = ((rows, numberInOrder, index) => {
    for (let i = 0; i < rows.length; i++) {
      if (index !== i && rows[i].numberInOrder >= numberInOrder) {
        return rows[i].numberInOrder > numberInOrder ? i - 1 : i;
      }
    }
    return rows.length - 1;
  })(rows, val.numberInOrder, index);

  if (index !== newIndex) {
    let start = newIndex;
    let finish = index - 1;
    let delta = 1;

    if (index < newIndex) {
      start = index + 1;
      finish = newIndex;
      delta = -1;
    }

    for (let i = start; i <= finish; i++) {
      let num = rows[i].numberInOrder + delta;
      if (num > 0) {
        rows[i].numberInOrder = num;
      }
    }
  }

  resortGalleryList(rows);

  return rows;
};

const getFileNames = rows => {
  return rows.map(r => getNameFromUrl(r.url));
};

const getUrlListFromValue = value => {
  return value[_lowerTypeGallery].map(v => v.url);
};

const getEditableObject = (galleries, editableUrl) => {
  let item = galleries.find(g => g.url === editableUrl);
  if (item) {
    let result = {
      url: item.url,
      fileName: getNameFromUrl(item.url),
      preview: item.preview,
      numberInOrder: item.numberInOrder
    };

    for (let lang in item.description) {
      result[lang] = item.description[lang];
    }

    return result;
  }

  return false;
};

const getGalleryListFromObject = (obj, currentLanguage) => {
  let result = [];
  if (obj) {
    let attrs = obj.data.find(d => d.languageId === currentLanguage);
    if (attrs) {
      let galleries = attrs.attributePreset.filter(
        attr => attr.gallery !== undefined
      );
      galleries.forEach(g => {
        g[_lowerTypeGallery].forEach(obj => {
          let { name, ext } = getPartsNameFromUrl(obj.url);

          result.push({
            url: obj.url,
            numberInOrder: obj.numberInOrder,
            preview: obj.preview,
            names: obj.names,
            description: obj.names.find(n => n.id === currentLanguage).value,
            fileName: name,
            fileExt: ext
          });
        });
      });
    }
  }
  return result;
};

const getNewGalleryForList = (obj, languages, url) => {
  const getDescription = (obj, languages) => {
    let result = {};

    languages.forEach(lang => {
      if (obj[lang.id] !== undefined) {
        result[lang.id] = obj[lang.id];
      }
    });

    return result;
  };

  return {
    numberInOrder: obj.numberInOrder,
    preview: obj.preview,
    url,
    description: getDescription(obj, languages)
  };
};

const isNewPhotoPreview = obj => obj.preview;

const getSelectedFileForCopy = list => {
  return list.map(c => {
    return {
      url: c.url,
      name: `${c.fileName}.${c.fileExt}`
    };
  });
};

const getUsedCopyNames = complexValue => {
  return complexValue.gallery.map(g => {
    return getNameFromUrl(g.url);
  });
};

const getGalleryItemForCopy = (
  galleries,
  copyObject,
  currentLanguage,
  languages,
  url
) => {
  let items = getGalleryListFromObject(copyObject, currentLanguage);
  let item = items.find(item => item.url === url);
  if (item) {
    item.numberInOrder = getNextNumberInOrderNum(galleries);
    item.preview = false;
    item.description = _getDescription(item.names, languages);
  }
  return item;
};

const getPhotos = (infoItem, currentLang) => {
  return infoItem.map(t => {
    let name = t.names.find(n => n.id === currentLang);
    let description = name ? name.value : "";
    return {
      url: t.url,
      fileName: getNameFromUrl(t.url),
      description
    };
  });
};

export {
  getGalleryValueData,
  resortGalleryList,
  recalcGalleryOrderNum,
  getNextNumberInOrderNum,
  getFileNames,
  getUrlListFromValue,
  getEditableObject,
  getGalleryListFromObject,
  getSelectedFileForCopy,
  getUsedCopyNames,
  getGalleryItemForCopy,
  getNewGalleryForList,
  isNewPhotoPreview,
  getPhotos
};
